import { roles } from '../../constants';
export const securityNavigation = {
    linkText: 'Security',
    props: { to: '/security' },
    permissions: [roles.Admin.ADMIN_SECURITY],
    children: []
}